import colors from "#/css/variables/_colors.module.scss"

export const fleFormTheme = {
  name: "fleFormTheme",
  borderColor: "rgba(0, 0, 0, 0.25)",
  disabledBackgroundColor: colors.chardon,
  checkedCheckboxBackgroundColor: colors.white,
  checkboxCheckColor: "#e48400"
}
